/**
 * Delay to auto close clipboard alert 3s
 */
export const AUTOCLOSE_ALERT_DELAY = 3000;
